module.exports = __webpack_public_path__ + "img/staci_20_ceny_bytu.020432cb.svg";